var lib_core = require("lib-core");

var ZoomingModel = function (editorModel, cameraModel) {
    this.editorModel = editorModel;
    this.cameraModel = cameraModel;

    lib_core.Model.apply(this);
};
lib_core.inherit(ZoomingModel, lib_core.Model);
lib_core.JsonParser.registerClass(ZoomingModel, "ZoomingModel");

module.exports = ZoomingModel;

ZoomingModel.prototype.zoom = function(steps,x,y) {
    var speed = 0.90;

    var changeX=0;
    var changeY=0;
    var changeS=1;

    if (steps < 0) {
        changeX = (1 / speed - 1) * x / this.cameraModel.viewS();
        changeY = (1 / speed - 1) * y / this.cameraModel.viewS();
        changeS = speed;
    } else {
        changeX = (speed - 1) * x / this.cameraModel.viewS();
        changeY = (speed - 1) * y / this.cameraModel.viewS();
        changeS = 1 / speed;
    }

    if (this.cameraModel.viewS()*changeS < this.cameraModel.viewSmin) {
        this.cameraModel.viewX(this.cameraModel.viewX() + ((this.cameraModel.viewS()/this.cameraModel.viewSmin - 1) * x / this.cameraModel.viewS()));
        this.cameraModel.viewY(this.cameraModel.viewY() + ((this.cameraModel.viewS()/this.cameraModel.viewSmin - 1) * y / this.cameraModel.viewS()));
        this.cameraModel.viewS(this.cameraModel.viewSmin);
    } else if (this.cameraModel.viewS()*changeS > this.cameraModel.viewSmax) {
        this.cameraModel.viewX(this.cameraModel.viewX() + ((this.cameraModel.viewS()/this.cameraModel.viewSmax - 1) * x / this.cameraModel.viewS()));
        this.cameraModel.viewY(this.cameraModel.viewY() + ((this.cameraModel.viewS()/this.cameraModel.viewSmax - 1) * y / this.cameraModel.viewS()));
        this.cameraModel.viewS(this.cameraModel.viewSmax);
    } else {
        if (changeX) this.cameraModel.viewX(this.cameraModel.viewX() + changeX);
        if (changeY) this.cameraModel.viewY(this.cameraModel.viewY() + changeY);
        if (changeS != 1) this.cameraModel.viewS(this.cameraModel.viewS() * changeS);
    }
};
ZoomingModel.prototype.zoomCenter = function(direction){

    var editorModelRect = this.editorModel.canvasRect();
    var height = editorModelRect.height;
    var width = editorModelRect.width;

    var centerX = width / 2;
    var centerY = height / 2;

    this.zoom(direction, centerX, centerY);
};

ZoomingModel.prototype.zoomSelection = function() {
    var self = this;

    var boundingBox = null;
    self.selection.forEach(function(selection){
        var selectionBoundingBox = selection && selection.getBoundingBox && selection.getBoundingBox();
        if (selectionBoundingBox) boundingBox = selectionBoundingBox.merge(boundingBox);
    });

    if (boundingBox) self.zoomBox(boundingBox.scale(1.2));

};

ZoomingModel.prototype.zoomToFit = function() {

    var bb = this.cameraModel.getBoundingBox && this.cameraModel.getBoundingBox(); // Get BB of devices onscreen

    if (bb) bb = bb.scale(1.2); // zoom out 20%
    else    bb = this.cameraModel.defaultWorkPlane().scale(1.05); // Deal with an empty bounding box: zoom to default workplane

    this.zoomBox(bb);
};

ZoomingModel.prototype.zoomBox = function(bb) {
    var holder = this.editorModel.canvasRect();

    if (bb.getArea() != 0 && holder.getArea() != 0) {

        if (holder.width / bb.width > holder.height / bb.height) {
            this.cameraModel.viewS( holder.height / bb.height);
        } else {
            this.cameraModel.viewS( holder.width / bb.width);
        }

        if (this.cameraModel.viewS() < this.cameraModel.viewSmin) {
            this.cameraModel.viewS( this.cameraModel.viewSmin );
        } else if (this.cameraModel.viewS() > this.cameraModel.viewSmax) {
            this.cameraModel.viewS( this.cameraModel.viewSmax);
        }

        this.cameraModel.viewX(-bb.x + 0.5*(holder.width-bb.width*this.cameraModel.viewS()) /this.cameraModel.viewS());
        this.cameraModel.viewY( bb.y + 0.5*(holder.height+bb.height*this.cameraModel.viewS()) /this.cameraModel.viewS());
    }
};
